module.exports = __webpack_public_path__ + "img/Group.8b6b595d.png";